import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types"
import * as myActions from "./RegisterPageApi";
import {
    Button,
    Checkbox,
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    OverlayTrigger,
    Row,
    Tooltip,
    Well
} from 'react-bootstrap'
import {browserHistory, Link} from "react-router";
import {addAlert} from "../App/actions";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import './RegisterWidget.scss'
import Dollars from "../../components/Dollars";
import {faBuilding, faFlag, faHandHoldingUsd, faInfoCircle, faUser} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {PaymentElement} from "./StripeCardRegister";
import MDSpinner from "react-md-spinner";
import {isEmailValid} from "../../common/commonHandlers";
import classNames from 'classnames';

const actions = {...myActions, addAlert};

const RegisterWidget = ({...props}) => {
    const [errors, setErrors] = useState({
        company_name: '',
        address_1: '',
        country: '',
        county: '',
        phone_number: '',
        city: '',
        state: '',
        zip: '',
        city_state_zip: '',
        email_address: '',
        password: '',
        confirm_password: '',
        first_name: '',
        last_name: '',
        job_title: ''
    })
    const [company_name, setCompany_name] = useState("")
    const [address_1, setAddress_1] = useState("")
    const [country, setCountry] = useState("United States")
    const [county, setCounty] = useState("")
    const [smsOptIn, setSmsOptIn] = useState(false)
    const [city, setCity] = useState("")
    const [state, setState] = useState("")
    const [zip, setZip] = useState("")
    const [phone_number, setPhone_number] = useState("")
    const [email_address, setEmail_address] = useState("")
    const [first_name, setFirst_name] = useState("")
    const [last_name, setLast_name] = useState("")
    const [job_title, setJob_title] = useState("")
    const [password, setPassword] = useState("")
    const [confirm_password, setConfirm_password] = useState("")
    const [view, setView] = useState("Company")
    const [companyCreated, setCompanyCreated] = useState(null)
    const [userCreated, setUserCreated] = useState(false)
    const [total_price, setTotal_price] = useState(0)
    const [isValidCard, setIsValidCard] = useState(false)
    const [stripePaymentMethod, setStripePaymentMethod] = useState()
    const [stripeClient, setStripeClient] = useState()
    const [stripePublishableKey, setStripePublishableKey] = useState()
    const [pendingSubscription, setPendingSubscription] = useState()
    const [paymentError, setPaymentError] = useState('')
    const [activated, setActivated] = useState(false)
    const [token, setToken] = useState()
    const [loading, setLoading] = useState(false)
    const [firstUserPrice, setFirstUserPrice] = useState(0)
    const [userPrice, setUserPrice] = useState(0)

    const {getPrices, getApiKey} = props.actions;
    useEffect(() => {
        getPrices(prices => {
            setTotal_price(prices.first)
            setFirstUserPrice(prices.first)
            setUserPrice(prices.next)
        })
        getApiKey(res => {
            setStripePublishableKey(res.api_key)
        })
        if (window.location.href.includes('?token=')) {
            let url = window.location.href
            let tok = url.substr(url.length - 7)

            const {activateAccount} = props.actions
            activateAccount(tok, response => {
                if (response.activated) {
                    setActivated(true)
                    setToken(tok)
                    setView('Finish')
                } else {
                    setActivated(false)
                    setToken(tok)
                    setView('Finish')
                }
            })

        }
    }, [])
    const validateEmailAndPassword = (errors) => {
        let valid = true;
        Object.keys(errors).forEach((key) => {
            if (errors[key] && errors[key].length > 0) {
                valid = false;
            }
        });

        if (errors.email_address.length > 0 || errors.password.length > 0 || errors.confirm_password.length > 0) {
            valid = false
        }
        if (email_address.length < 1 || password.length < 1 || confirm_password.length < 1 || first_name.length < 1 || last_name.length < 1 ||
            job_title.length < 1) {
            valid = false
        }
        return valid
    }

    const validateForm = (errors) => {
        let valid = true;
        Object.keys(errors).forEach((key) => {
            if (view === 'Company' && !['confirm_password', 'email_address', 'password', 'first_name', 'last_name', 'job_title'].includes(key)) {
                if (errors[key] && errors[key].length > 0) {
                    valid = false;
                }
            }
        });

        if (company_name.length < 1 || address_1.length < 1 || country.length < 1 || city.length < 1 || state.length < 1
            || zip.length < 1) {
            valid = false
        }
        return valid
    }
    const handleAddressChange = (e) => {
        let err = errors;
        const {value} = e.target;
        setAddress_1(value)
        err.address_1 = value.length < 1 ? 'Address is required.' : '';
        setErrors(err);
        validateForm(errors)
    }
    const handleNameChange = (e) => {
        e.preventDefault()
        let err = errors;
        const {value} = e.target;
        setCompany_name(value)
        err.company_name = value.length < 1 ? 'Company name is required.' : ''
        setErrors(err);
        validateForm(errors)
    }
    const handleFirstNameChange = (e) => {
        e.preventDefault()
        let err = errors;
        const {value} = e.target;
        setFirst_name(value)
        err.first_name = value.length < 1 ? 'First Name is required.' : ''
        setErrors(err);
        validateForm(errors)
    }
    const handleLastNameChange = (e) => {
        e.preventDefault()
        let err = errors;
        const {value} = e.target;
        setLast_name(value)
        err.last_name = value.length < 1 ? 'Last Name is required.' : ''
        setErrors(err);
        validateForm(errors)
    }
    const handleJobTitleChange = (e) => {
        e.preventDefault()
        let err = errors;
        const {value} = e.target;
        setJob_title(value)
        err.job_title = value.length < 1 ? 'Job Title is required.' : ''
        setErrors(err);
        validateForm(errors)
    }
    const handleEmailChange = (e) => {
        e.preventDefault()
        let err = errors;
        const {value} = e.target;
        setEmail_address(value)
        err.email_address =
            isEmailValid(value) ? '' : value.length < 1 ? 'Email is required.' : 'Email is not valid.'
        setErrors(err);
        validateForm(errors)
    }
    const handlePasswordChange = (e) => {
        e.preventDefault()
        let err = errors;
        const {value} = e.target;
        setPassword(value)
        err.password =
            value.length < 6
                ? 'Password must be 6 characters long.'
                : '';
        err.confirm_password =
            confirm_password !== value
                ? "Passwords don't match."
                : '';
        setErrors(err);
        validateForm(errors)
    }
    const handleConfirmChange = (e) => {
        e.preventDefault()
        let err = errors;
        const {value} = e.target;
        setConfirm_password(value)
        err.confirm_password =
            password !== value
                ? "Passwords don't match."
                : '';
        setErrors(err);
        validateForm(errors)
    }
    const handleZipChange = (e) => {
        e.preventDefault()
        const {fetchStateAndCityForCustomer} = props.actions;
        let err = errors;
        const {value} = e.target;
        setZip(value)
        if (value.length === 5) {
            fetchStateAndCityForCustomer(value, (response) => {
                if (response.city) {
                    setCity(response.city)
                }
                if (response.state) {
                    setState(response.state)
                }
            })
        }
        err.zip =
            value.length !== 5
                ? 'Zip is invalid.'
                : '';
        err.city_state_zip = '';
        setErrors(err);
        validateForm(errors)
    }
    const handleStateChange = (e) => {
        e.preventDefault()
        let err = errors;
        const {value} = e.target;
        setState(value)
        err.state =
            value.length < 1
                ? 'State is required.'
                : '';
        err.city_state_zip = '';
        setErrors(err);
        validateForm(errors)
    }

    const handleCityChange = (e) => {
        e.preventDefault()
        let err = errors;
        const {value} = e.target;
        setCity(value)
        err.city =
            value.length < 1
                ? 'City is required.'
                : '';
        err.city_state_zip = '';
        setErrors(err);
        validateForm(errors)
    }

    const handleCountryChange = (e) => {
        e.preventDefault()
        let err = errors;
        const {value} = e.target;
        setCountry(value)
        err.country =
            value.length < 1
                ? 'Country is required.'
                : '';
        setErrors(err);
        validateForm(errors)
    }

    const handleCountyChange = (e) => {
        e.preventDefault()
        const {value} = e.target;
        setCounty(value)
    }

    const handlePhoneChange = (e) => {
        e.preventDefault();
        const {value} = e.target;
        let err = errors;
        setPhone_number(value);

        const phoneRegex = /^(?:\+\d{1,3}\s?)?(?:\d{3}|\(\d{3}\))[-.\s]?\d{3}[-.\s]?\d{4}(?:\s(?:x|ext)\s\d+)?$|^$/;

        if (!phoneRegex.test(value)) {
            err.phone_number = 'Invalid phone number format.';
        } else {
            err.phone_number = '';
        }

        setErrors(err);
        validateForm(errors);
    };


    const checkValidation = (callback) => {
        const {checkUniqueEmail, checkUniqueName} = props.actions;
        const email = email_address;
        const name = company_name;
        let valid = true;

        if (view !== 'Company') {
            checkUniqueEmail(email, null, false, (response) => {
                setErrors({
                    ...errors,
                    email_address: response.unique ? '' : 'Client email already exist.'
                });
                if (!response.unique) {
                    valid = false;
                }
                callback(valid);
            });
        }

        if (view === 'Company') {
            checkUniqueName(name, (response) => {
                setErrors({
                    ...errors,
                    company_name: response.unique ? '' : 'Company name already exist.'
                });
                if (!response.unique) {
                    valid = false;
                }
                callback(valid);
            });
        }
    }

    const showPaymentError = errors => {
        setPaymentError(Array.isArray(errors) ? errors.join(' ') : 'Unexpected error occurred.')
        setLoading(false)
    }

    const finishRegistration = subscriptionId => props.actions.createClient(subscriptionId, response => {
        if (response?.id) {
            setLoading(false)
            setView('Finish')
        } else {
            showPaymentError(response?.errors)
        }
    })

    const confirmSubscription = subscription => stripeClient.handleCardPayment(subscription.clientSecret)
        .then(result => {
            if (result.error) {
                setPaymentError(result.error.message)
                setLoading(false)
                return
            }

            setPendingSubscription({...subscription, paid: true})
            finishRegistration(subscription.id)
        })
        .catch(error => {
            setPaymentError(error.message)
            setLoading(false)
        })

    const submitPayment = e => {
        const {prepareSubscription} = props.actions;
        e.preventDefault();
        setPaymentError('')
        setLoading(true)

        if (pendingSubscription) {
            pendingSubscription.paid
                ? finishRegistration(pendingSubscription.id)
                : confirmSubscription(pendingSubscription)
            return
        }

        let new_client = {
            address_1: address_1,
            city: city,
            country: country,
            county: county,
            email_address: email_address,
            name: company_name,
            phone_number: phone_number,
            state: state,
            zip: zip,
            sms_opt_in: smsOptIn
        }

        let user_password = {
            password: password,
        }

        let user_details = {
            first_name: first_name,
            last_name: last_name,
            job_title: job_title
        }

        prepareSubscription(new_client, user_password, companyCreated, stripePaymentMethod, user_details, response => {
            if (response?.subscription_id) {
                const subscription = {
                    id: response.subscription_id,
                    clientSecret: response.client_secret,
                    paid: response.status === 'active'
                }
                setPendingSubscription(subscription)
                response.status === 'active'
                    ? finishRegistration(subscription.id)
                    : confirmSubscription(subscription)
            } else {
                showPaymentError(response?.errors)
            }
        })
    };
    const validateFormData = () => {
        if (companyCreated) {
            return view === 'Company' ? validateForm(errors) : validateEmailAndPassword(errors);
        }
        return validateForm(errors);
    };

    const createNewRegister = () => ({
        id: companyCreated && companyCreated,
        address_1: address_1,
        city: city,
        country: country,
        county: county,
        email_address: email_address,
        name: company_name,
        phone_number: phone_number,
        state: state,
        zip: zip,
        first_name: first_name,
        last_name: last_name,
        job_title: job_title
    });

    const registerUser = (e) => {
        const {createRegister} = props.actions;
        e.preventDefault();

        checkValidation((valid) => {
            if (valid && validateFormData()) {
                const new_register = createNewRegister();

                createRegister(new_register, (created_register) => {
                    if (created_register) {
                        setCompanyCreated(created_register.id);
                        if (companyCreated) {
                            setView(view === 'Company' ? "User" : "Payment");
                            if (view !== 'Company') {
                                setUserCreated(true);
                            }
                        } else {
                            setView("User");
                        }
                    }
                });
            }
        });
    };

    const handleUserViewChange = (viewType) => {
        const {createRegister} = props.actions;

        checkValidation((valid) => {
            if (valid && validateFormData()) {
                const new_register = createNewRegister();

                createRegister(new_register, (created_register) => {
                    if (created_register) {
                        if (viewType === 'User' && companyCreated) {
                            setView(viewType);
                        }
                        if (viewType === 'Payment' && userCreated) {
                            setView(viewType);
                        }
                    }
                });
            }
        });
    };


    return (
        <div className='register-widget'>
            {view === 'Company' && <Well>
                <h4>Sign Up</h4>
                <p>&nbsp;</p>

                <form onSubmit={e => registerUser(e)}>
                    <FormGroup className='registration-progress-container'>
                        <Row className="registration-progress">
                            <Col md={2} className='progress-wrapper'>
                                <div className='registration-active'>
                                    <FontAwesomeIcon icon={faBuilding}
                                                     className="bigger"/>
                                </div>
                                <div>Company</div>
                            </Col>

                            <span className="registration-progress-bar"></span>
                            <Col md={2} className='progress-wrapper'>
                                <div
                                    className={classNames('registration-disabled', {'registration-pointer': companyCreated})}
                                    onClick={() => handleUserViewChange('User')}>
                                    <FontAwesomeIcon icon={faUser}
                                                     className="bigger"/>
                                </div>
                                <div>User</div>
                            </Col>
                            <span className="registration-progress-bar"></span>
                            <Col md={2} className='progress-wrapper'>
                                <div
                                    className={classNames('registration-disabled', {'registration-pointer': userCreated})}
                                    onClick={() => handleUserViewChange('Payment')}>
                                    <FontAwesomeIcon icon={faHandHoldingUsd}
                                                     className="bigger"/>
                                </div>
                                <div>Payment</div>
                            </Col>
                            <span className="registration-progress-bar"></span>
                            <Col md={2} className='progress-wrapper'>
                                <div className='registration-disabled'>
                                    <FontAwesomeIcon icon={faFlag}
                                                     className="bigger"/>
                                </div>
                                <div>Finish</div>
                            </Col>
                        </Row>
                    </FormGroup>
                    <h3>Company Details</h3>
                    <FormGroup>
                        <ControlLabel>Company Name</ControlLabel>
                        <FormControl
                            name="company_name"
                            onChange={e => handleNameChange(e)}
                            value={company_name}
                            style={{
                                borderColor: errors.company_name ? 'red' : undefined
                            }}
                        />
                        {errors.company_name.length > 0 &&
                            <span className='error'>{errors.company_name}</span>}
                    </FormGroup>
                    <FormGroup>
                        <ControlLabel>Phone</ControlLabel>
                        <FormControl
                            name="phone_number"
                            onChange={e => handlePhoneChange(e)}
                            value={phone_number}
                            style={{
                                borderColor: errors.phone_number ? 'red' : undefined
                            }}
                        />
                        {errors.phone_number.length > 0 &&
                            <span className='error'>{errors.phone_number}</span>}
                    </FormGroup>
                    <FormGroup>
                        <ControlLabel>Address</ControlLabel>
                        <FormControl
                            name="city"
                            onChange={e => handleAddressChange(e)}
                            value={address_1}
                            style={{
                                borderColor: errors.address_1 ? 'red' : undefined
                            }}
                        />
                        {errors.address_1.length > 0 && !errors.city_state_zip  &&
                            <span className='error'>{errors.address_1}</span>}
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col md={6}>
                                <ControlLabel>City</ControlLabel>
                                <FormControl
                                    name="city"
                                    onChange={e => handleCityChange(e)}
                                    value={city}
                                    style={{
                                        borderColor: errors.city || errors.city_state_zip ? 'red' : undefined
                                    }}
                                />
                            </Col>
                            <Col md={3}>
                                <ControlLabel>State</ControlLabel>
                                <FormControl
                                    name="state"
                                    onChange={e => handleStateChange(e)}
                                    value={state}
                                    style={{
                                        borderColor: errors.state || errors.city_state_zip ? 'red' : undefined
                                    }}
                                />
                            </Col>
                            <Col md={3}>
                                <ControlLabel>Zip</ControlLabel>
                                <FormControl
                                    name="zip"
                                    onChange={e => handleZipChange(e)}
                                    value={zip}
                                    style={{
                                        borderColor: errors.zip || errors.city_state_zip ? 'red' : undefined
                                    }}
                                />
                            </Col>
                        </Row>
                        {errors.city.length > 0 &&
                            <span className='error'>{errors.city}</span>}
                        {errors.state.length > 0 &&
                            <span className='error'>{errors.state}</span>}
                        {errors.zip.length > 0 &&
                            <span className='error'>{errors.zip}</span>}
                        {errors.city_state_zip.length > 0 &&
                            <span className='error'>{errors.city_state_zip}</span>}
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col md={6}>
                                <ControlLabel>Country</ControlLabel>
                                <FormControl
                                    name="country"
                                    onChange={e => handleCountryChange(e)}
                                    value={country}
                                    style={{
                                        borderColor: errors.country ? 'red' : undefined
                                    }}
                                />
                            </Col>
                            <Col md={6}>
                                <ControlLabel>County</ControlLabel>
                                <FormControl
                                    name="county"
                                    onChange={e => handleCountyChange(e)}
                                    value={county}
                                    style={{
                                        borderColor: errors.county ? 'red' : undefined
                                    }}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col md={12}>
                                <Checkbox
                                    inline
                                    checked={smsOptIn}
                                    onChange={e => setSmsOptIn(e.currentTarget.checked)}
                                >
                                    I agree to receive transactional SMS messages from TreeHub
                                </Checkbox>
                                <OverlayTrigger placement="right"
                                                overlay={<Tooltip id="tooltip">
                                                    <div className="text-left">
                                                        We send you notifications about crew messages, invoices etc.
                                                        via SMS
                                                    </div>
                                                </Tooltip>}>
                                    <FontAwesomeIcon icon={faInfoCircle} className="marginLeft10 font16"/>
                                </OverlayTrigger>
                            </Col>
                        </Row>
                    </FormGroup>
                    {errors.country.length > 0 &&
                        <span className='error'>{errors.country}</span>}
                    {errors.county.length > 0 &&
                        <span className='error'>{errors.county}</span>}
                    <div className='button-container'>

                        <Button bsStyle="success" type="submit">
                            Next
                        </Button>
                    </div>
                </form>
                <p>&nbsp;</p>
                <p>Already have an account? <Link to="login">Login</Link></p>
            </Well>}
            {view === 'User' &&
                <Well>
                    <h4>Sign Up</h4>
                    <p>&nbsp;</p>
                    <form onSubmit={e => registerUser(e)}>
                        <FormGroup className='registration-progress-container'>
                            <Row className="registration-progress">
                                <Col md={2} className='progress-wrapper'>
                                    <div
                                        className={classNames('registration-disabled', {'registration-pointer': companyCreated})}
                                        onClick={() => setView('Company')}>
                                        <FontAwesomeIcon icon={faBuilding}
                                                         className="bigger"/>
                                    </div>
                                    <div>Company</div>
                                </Col>

                                <span className="registration-progress-bar"></span>
                                <Col md={2} className='progress-wrapper'>
                                    <div className='registration-active' onClick={() => handleUserViewChange('User')}>
                                        <FontAwesomeIcon icon={faUser}
                                                         className="bigger"/>
                                    </div>
                                    <div>User</div>
                                </Col>
                                <span className="registration-progress-bar"></span>
                                <Col md={2} className='progress-wrapper'>
                                    <div
                                        className={classNames('registration-disabled', {'registration-pointer': userCreated})}
                                        onClick={() => handleUserViewChange('Payment')}>
                                        <FontAwesomeIcon icon={faHandHoldingUsd}
                                                         className="bigger"/>
                                    </div>
                                    <div>Payment</div>
                                </Col>
                                <span className="registration-progress-bar"></span>
                                <Col md={2} className='progress-wrapper'>
                                    <div className='registration-disabled'>
                                        <FontAwesomeIcon icon={faFlag}
                                                         className="bigger"/>
                                    </div>
                                    <div>Finish</div>
                                </Col>
                            </Row>
                        </FormGroup>
                        <h3>Primary Admin</h3>
                        <FormGroup>
                            <ControlLabel>First Name</ControlLabel>

                            <FormControl
                                name="first_name"
                                onChange={e => handleFirstNameChange(e)}
                                value={first_name}
                                style={{
                                    borderColor: errors.first_name ? 'red' : undefined
                                }}
                            />
                            {errors.first_name.length > 0 &&
                                <span className='error'>{errors.first_name}</span>}
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Last Name</ControlLabel>

                            <FormControl
                                name="last_name"
                                onChange={e => handleLastNameChange(e)}
                                value={last_name}
                                style={{
                                    borderColor: errors.last_name ? 'red' : undefined
                                }}
                            />
                            {errors.last_name.length > 0 &&
                                <span className='error'>{errors.last_name}</span>}
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Job Title</ControlLabel>

                            <FormControl
                                name="job_title"
                                onChange={e => handleJobTitleChange(e)}
                                value={job_title}
                                style={{
                                    borderColor: errors.job_title ? 'red' : undefined
                                }}
                            />
                            {errors.job_title.length > 0 &&
                                <span className='error'>{errors.job_title}</span>}
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Email</ControlLabel>

                            <FormControl
                                type="email"
                                name="email_address"
                                onChange={e => handleEmailChange(e)}
                                value={email_address}
                                style={{
                                    borderColor: errors.email_address ? 'red' : undefined
                                }}
                            />
                            {errors.email_address.length > 0 &&
                                <span className='error'>{errors.email_address}</span>}
                        </FormGroup>
                        {errors.phone_number.length > 0 &&
                            <span className='error'>{errors.phone_number}</span>}
                        <FormGroup>
                            <ControlLabel>Password</ControlLabel>
                            <FormControl
                                name="password"
                                type="password"
                                onChange={e => handlePasswordChange(e)}
                                value={password}
                                style={{
                                    borderColor: errors.password ? 'red' : undefined
                                }}
                            />
                            {errors.password.length > 0 &&
                                <span className='error'>{errors.password}</span>}
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Confirm Password</ControlLabel>
                            <FormControl
                                name="confirm_password"
                                type="password"
                                onChange={e => handleConfirmChange(e)}
                                value={confirm_password}
                                style={{
                                    borderColor: errors.confirm_password ? 'red' : undefined
                                }}
                            />
                            {errors.confirm_password.length > 0 &&
                                <span className='error'>{errors.confirm_password}</span>}
                        </FormGroup>
                        <div className='button-container'>
                            <Button bsStyle="danger" type="button" onClick={() => {
                                setView('Company')
                            }}>
                                Previous
                            </Button>
                            <Button bsStyle="success" type="submit">
                                Next
                            </Button>
                        </div>
                    </form>
                </Well>
            }
            {view === 'Payment' &&
                <Well>
                    <h4>Sign Up</h4>
                    <p>&nbsp;</p>
                    <form onSubmit={e => submitPayment(e)}>
                        <FormGroup className='registration-progress-container'>
                            <Row className="registration-progress">
                                <Col md={2} className='progress-wrapper'>
                                    <div
                                        className={classNames('registration-disabled', {'registration-pointer': companyCreated})}
                                        onClick={() => {
                                            if (!pendingSubscription?.paid) {
                                                setPendingSubscription(null)
                                                setView("Company")
                                            }
                                        }}>
                                        <FontAwesomeIcon icon={faBuilding}
                                                         className="bigger"/>
                                    </div>
                                    <div>Company</div>
                                </Col>

                                <span className="registration-progress-bar"></span>
                                <Col md={2} className='progress-wrapper'>
                                    <div
                                        className={classNames('registration-disabled', {'registration-pointer': userCreated})}
                                        onClick={() => {
                                            if (!pendingSubscription?.paid) {
                                                setPendingSubscription(null)
                                                setView("User")
                                            }
                                        }}>
                                        <FontAwesomeIcon icon={faUser}
                                                         className="bigger"/>
                                    </div>
                                    <div>User</div>
                                </Col>
                                <span className="registration-progress-bar"></span>
                                <Col md={2} className='progress-wrapper'>
                                    <div className='registration-active'>
                                        <FontAwesomeIcon icon={faHandHoldingUsd}
                                                         className="bigger"/>
                                    </div>
                                    <div>Payment</div>
                                </Col>
                                <span className="registration-progress-bar"></span>
                                <Col md={2} className='progress-wrapper'>
                                    <div className='registration-disabled'>
                                        <FontAwesomeIcon icon={faFlag}
                                                         className="bigger"/>
                                    </div>
                                    <div>Finish</div>
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <PaymentElement setIsValidCard={setIsValidCard}
                                            setStripePaymentMethod={setStripePaymentMethod}
                                            setStripeClient={setStripeClient}
                                            stripePublishableKey={stripePublishableKey} loading={loading}/>
                            {paymentError && <div className="error text-danger text-center" role="alert">
                                <strong>{paymentError}</strong>
                            </div>}
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col md={12} style={{textAlign: 'right'}}>
                                    <h4><ControlLabel><strong>Total Price: <Dollars
                                        amount={total_price}/> / month</strong></ControlLabel></h4>
                                    <h6>
                                        <Dollars amount={firstUserPrice}/> first user / <Dollars
                                        amount={userPrice}/> each
                                        additional user.
                                    </h6>
                                    <h6>Additional users may be added in the app.</h6>
                                </Col>
                            </Row>
                        </FormGroup>
                        <div className='button-container'>
                            {!loading && <Button bsStyle="danger" type="button" onClick={() => {
                                if (!pendingSubscription?.paid) {
                                    setPendingSubscription(null)
                                    setView('User')
                                }
                            }}>
                                Previous
                            </Button>}
                            <Button bsStyle="success" type="submit" disabled={!isValidCard || loading}>
                                {loading ? <MDSpinner/> : 'Pay'}
                            </Button>

                        </div>

                    </form>
                </Well>
            }
            {view === 'Finish' &&
                <Well>
                    <h4>Sign Up</h4>
                    <p>&nbsp;</p>
                    <form>
                        <FormGroup className='registration-progress-container'>
                            <Row className="registration-progress">
                                <Col md={2} className='progress-wrapper'>
                                    <div className='registration-disabled'>
                                        <FontAwesomeIcon icon={faBuilding}
                                                         className="bigger"/>
                                    </div>
                                    <div>Company</div>
                                </Col>

                                <span className="registration-progress-bar"></span>
                                <Col md={2} className='progress-wrapper'>
                                    <div className='registration-disabled'>
                                        <FontAwesomeIcon icon={faUser}
                                                         className="bigger"/>
                                    </div>
                                    <div>User</div>
                                </Col>
                                <span className="registration-progress-bar"></span>
                                <Col md={2} className='progress-wrapper'>
                                    <div className='registration-disabled'>
                                        <FontAwesomeIcon icon={faHandHoldingUsd}
                                                         className="bigger"/>
                                    </div>
                                    <div>Payment</div>
                                </Col>
                                <span className="registration-progress-bar"></span>
                                <Col md={2} className='progress-wrapper'>
                                    <div className='registration-active'>
                                        <FontAwesomeIcon icon={faFlag}
                                                         className="bigger"/>
                                    </div>
                                    <div>Finish</div>
                                </Col>
                            </Row>
                        </FormGroup>
                    </form>
                    {activated ? <div className="register-finish">
                        <h4>Congratulations!</h4>
                        <h5>Now you can log in to Treehub</h5>
                        <Button bsStyle='success' onClick={() => browserHistory.push('/login')}>
                            Log In
                        </Button>
                    </div> : token ?
                        <div className="register-finish">
                            <h4 style={{color: 'red'}}>Cannot activate an account</h4>
                            <h5>Please contact us for more information info@treehub.me</h5>
                        </div>
                        :
                        <div className="register-finish">
                            <h4>Done!</h4>
                            <h5>To activate your Treehub account click on the link in account activation email.</h5>
                        </div>
                    }


                </Well>
            }
        </div>
    )
}

RegisterWidget.propTypes = {
    client: PropTypes.string,
    email: PropTypes.string,
    password: PropTypes.string,

}

function mapStateToProps(state) {
    return {
        client: state.auth.client,
        email: state.email,
        roles: state.auth.roles,
        password: state.password,
        auth: state.auth,
        state
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterWidget);

